<div class="dialog-container">
  <h2 mat-dialog-title>Categories</h2>
  
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <mat-dialog-content>
      <p class="dialog-description">Placeholder Text explaining what categories are</p>
      <div class="categories-section">
        <h3>Select all that apply</h3>
        <div class="categories-grid">
          @for (category of availableCategories; track category.id) {
            <mat-checkbox 
              [checked]="isCategorySelected(category)"
              (change)="toggleCategory(category)"
              class="category-checkbox">
              {{ category.name }}
            </mat-checkbox>
          }
        </div>
      </div>
      
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button  type="submit">
        Apply Changes
      </button>
    </mat-dialog-actions>
  </form>
</div>
